import React from 'react'
import { useInView } from 'react-intersection-observer'

type AnimationProps = {
  disabled?: boolean
} & React.PropsWithChildren

const Animation: React.FC<AnimationProps> = ({ disabled, children }) => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true
  })

  if (disabled === true) {
    return <>{children}</>
  }
  return (
    <div ref={ref} className={`animated ${inView ? 'start-animation' : ''}`}>
      {children}
    </div>
  )
}

export default Animation
